export const UseCaseTypes = {
  MAIN_BLOG: 'Main Blog',
  HR_BLOG: 'HR Blog',
  COMMUNITY_BLOG: 'Community Blog',
  SECONDARY_BLOG: 'Secondary Blog',
}

export const secondaryBlogBreadcrumbs = {
  [UseCaseTypes.HR_BLOG]: '/hr-blog',
  [UseCaseTypes.COMMUNITY_BLOG]: '/community-blog',
}

export const blogUseCaseUrlMappings: any = {
  [UseCaseTypes.HR_BLOG]: 'inside-the-rocketship',
  [UseCaseTypes.COMMUNITY_BLOG]: 'community-blog',
}
